import Flickity from "flickity";

class CarouselCottage {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.CarouselElem = self.elem.querySelector('[data-carousel]');
        self.CarouselSlideElems = self.elem.querySelectorAll('[data-slides]'); // Use querySelectorAll to get all slide elements

    }

    init() {
        let self = this;

        self.initCarousels();
    }

    initCarousels() {
        let self = this;

        self.flkty = new Flickity(self.CarouselElem, {
            // Flickity options...
            prevNextButtons: false,
            arrowShape: 'M 403.2 49 H 8 l 21.2 -19.2 c 0.8 -0.8 0.8 -2 0 -2.8 c -0.8 -0.8 -2 -0.8 -2.8 0 L 1.6 49 C 1.2 49.4 0.8 49.8 0.8 50.6 c 0 0.8 0.4 1.2 0.8 1.6 l 24.8 22 c 0.4 0.4 0.8 0.4 1.2 0.4 c 0.8 0 1.2 0 1.2 -0.4 c 0.8 -0.8 0.8 -2 0 -2.8 L 8 53 h 99.6 c 0.8 0 1.6 -0.8 1.6 -2 S 108.4 49 107.2 49 z'
        });

        self.createListeners();
    }

    createListeners() {
        let self = this;

        // Add click event listener to each slide element
        self.CarouselSlideElems.forEach((slideElem, index) => {
            slideElem.addEventListener('click', () => {
                // Go to the clicked slide
                self.flkty.select(index);
            });
        });
    }
}

export default CarouselCottage;
